import { BROKER_DATA } from '../constant/constant';

const initialState = [];

export const BrokerReducer = (state = initialState, action) => {
  switch (action.type) {
    case BROKER_DATA:
      return action.payload;
    default:
      return state;
  }
};
